import { z } from "zod";
export const TestCaseSummary = z.object({
    id: z.string(),
    framework: z.string(),
    filePath: z.string().nullable(),
    suite: z.string().nullable(),
    name: z.string(),
    firstSeenAt: z.string().datetime(),
    lastSeenAt: z.string().datetime(),
});
export const TestCasesListResponse = z.object({
    testCases: z.array(TestCaseSummary),
});
export const TestCasesListQuery = z.object({
    framework: z.string().optional(),
    limit: z.coerce.number().int().positive().max(500).optional(),
});
//# sourceMappingURL=test-cases.js.map